export const playout = {
  playoutTableOpen: 'playout-table-open',
  playoutCalendarOpen: 'playout-calendar-open',
  playoutScteOpen: 'playout-scte-open',
  playoutViewScheduleOpen: 'playout-viewSchedule-open',
  playoutRunningBookingsOpen: 'playout-runningBookings-open',
  playoutPastBookingsOpen: 'playout-pastBookings-open',
  playoutCancelledBookingsOpen: 'playout-cancelledBookings-open',
  playoutVideoLive: 'playout-previewVideo-open',
  playoutVideoClose: 'playout-previewVideo-close',
  playoutCreateEventSave: 'playout-createEvent-save',
  playoutCreateScteAdd: 'playout-createScte-add',
  playoutCreateEventclose: 'playout-createEvent-close',
  playoutCreateScteclose: 'playout-createScte-close',
  playoutCreateBoxClose: 'playout-createBooking-close',
  playoutCreateBoxOpen: 'playout-createBooking-open',
  playoutDuplicateBoxOpen: 'playout-duplicateBox-open',
  playoutCalendarEventDetailBoxOpen: 'playout-calendarEventDetailBox-open',
  playoutTableEventEditOpen: 'playout-tableEventEdit-open',
  playoutScteEditOpen: 'playout-scteEdit-open',
  playoutCalendarEventEditOpen: 'playout-calendarEventEdit-open',
  playoutCalendarEventEditShow: 'playout-calendarEventEdit-show',
  playoutTableEventEditClose: 'playout-tableEventEdit-close',
  playoutScteEditClose: 'playout-scteEdit-close',
  playoutCalendarEventEditClose: 'playout-calendarEventEditOrCreate-close',
  playoutTableEventEditSave: 'playout-tableEventEdit-save',
  playoutScteEditSave: 'playout-scteEdit-save',
  playoutTableEventLiveEnd: 'playout-tableEventLive-end',
  playoutCalendarEventLiveEnd: 'playout-calendarEventLive-end',
  playoutTableEventDelete: 'playout-tableEvent-delete',
  playoutScteDelete: 'playout-scte-delete',
  playoutCalendarFilterIconClick: 'playout-calendarFilterBox-open',
  playoutSourceConditionClick: 'playout-sourceConditionBox-open',
  playoutRConditionClick: 'playout-rConditionBox-open',
  playoutBookmarkClick: 'playout-bookmarkList-open',
  playoutfilterClick: 'playout-filterList-open',
  playoutDatePreClick: 'playout-datePre-click',
  playoutDateNextClick: 'playout-dateNext-click',
  playoutDateFilterClick: 'playout-DateFilter-click',
  playoutScteDateFilterClick: 'playout-scteDateFilter-click',
  playoutLiveEventPlayClose: 'playout-liveEventPlay-close',
  playoutLiveEventPlayOpen: 'playout-liveEventPlay-open',
  playoutZoomOpen: 'playout-zoom-open',
  playoutZoomClose: 'playout-zoom-close',
  playoutZoomCreatedEventSave: 'playout-zoomCreatedEvent-save',
  playoutZoomCreatedBoxClose: 'playout-zoomCreatedBox-close',
  playoutZoomCreatedBoxOpen: 'playout-zoomCreatedBox-open',
  playoutZoomColorOpen: 'playout-zoomColor-open',
  playoutZoomColorChange: 'playout-zoomColor-change',
  playoutEventColorChange: 'playout-eventColor-Change',
  playoutEventColorOpen: 'playout-eventColor-open',
  playoutFileDelete: 'playout-file-delete',
  playoutFileSearchOpen: 'playout-fileSearch-open',
  playoutFileSearchClose: 'playout-fileSearch-close',
  playoutScteSearchClose: 'playout-scteSearch-close',
  playoutScteSearchOpen: 'playout-scteSearch-open',
  playoutSourceSearchClose: 'playout-sourceSearch-close',
  playoutSourceSearchOpen: 'playout-sourceSearch-open',
  playoutAddExt: 'playout-ext-add',
  playoutLoadFile: 'playout-file-load',
  playoutFileEditDelete: 'playout-file-edit-delete',
  playoutVideoAdd: 'playout-video-add',
  playoutVideoCancel: 'playout-video-cancel',
  // 以下是新加的
  playoutSelectLogoSave: 'playout-SelectLogo-Save',
  playoutScteSettingsStart: 'playout-ScteSettings-Start',
  playoutRightUpReStart: 'playout-RightUp-ReStart',
  playoutTakeBreakingSource: 'playout-TakeBreakingSource',
  playoutTakePlayList: 'playout-TakePlayList',
  playoutTakeNext: 'playout-TakeNext',
  playoutCopyEPGLink: 'playout-CopyEPGLink',
  playoutRightVideoVolumeUp: 'playout-RightVideoVolume-Up',
  playoutRightVideoVolumeOff: 'playout-RightVideoVolume-Off',
  playoutCenterVideoVolumeOff: 'playout-CenterVideoVolume-Off',
  playoutCenterVideoVolumeUp: 'playout-CenterVideoVolume-Up',
  playoutCalendarEventEditSave: 'playout-CalendarEvent-Edit-Save',
  playoutCalendarCreateEvent: 'playout-Calendar-CreateEvent',
  playoutCalendarEventDelete: 'playout-CalendarEvent-Delete',
  playoutCalendarEventsDeleteSubevent: 'playout-Calendar-Events-DeleteSubevent',
  playoutCalendarEventsAddSubevent: 'playout-Calendar-Events-AddSubevent',
  playoutCalendarEventDuplicate: 'playout-CalendarEvent-Duplicate',
  playoutLeftSourceMedia: 'playout-LeftSource-Media',
  playoutLeftSourceLiveSource: 'playout-LeftSource-LiveSource',
  playoutLeftSourceProgramTemplate: 'playout-LeftSource-ProgramTemplate',
  playoutLeftSourceScheduleTemplate: 'playout-LeftSource-ScheduleTemplate',
  playoutFileTreeHeaderSearchShow: 'playout-FileTreeHeader-SearchShow',
  playoutFileTreeHeaderAddFolder: 'playout-FileTreeHeader-AddFolder',
  playoutFileTreeHeaderUploadVideoFile: 'playout-FileTreeHeader-UploadVideoFile',
  playoutFileTreeHeaderRefreshList: 'playout-FileTreeHeader-RefreshList',
  playoutFileTreeAddFolder: 'playout-FileTree-AddFolder',
  playoutFileTreeDeleteFolder: 'playout-FileTree-DeleteFolder',
  schedulerFileTreeEditFile: 'scheduler-FileTree-EditFile',
  playoutFileTreeDeleteFile: 'playout-FileTree-DeleteFile',
  playoutLeftSourceClearVideo: 'playout-LeftSource-ClearVideo',
  playoutLeftVideoPlay: 'playout-LeftVideo-Play',
  playoutFileTreeHeaderAddFolderSave: 'playout-FileTreeHeader-AddFolder-Save',
  playoutProgramTemplateHeaderAddSave: 'playout-ProgramTemplate-Header-Add-Save'
}
export const ponentCom = {
  cascaderHideDirectory: 'cascader-HideDirectory',
  cascaderShowSecondaryDirectory: 'cascader-ShowSecondaryDirectory',
  cascaderShowTertiaryDirectory: 'cascader-ShowTertiaryDirectory',
  cascaderShowFourDirectory: 'cascader-ShowFourDirectory',
  cascaderHideSecondaryDirectory: 'cascader-HideSecondaryDirectory',
  cascaderHideTertiaryDirectory: 'cascader-HideTertiaryDirectory',
  cascaderHideFourDirectory: 'cascader-HideFourDirectory',
  cascaderSetCheck: 'cascader-SetCheck',
  pageLeftResourceClearVideo: 'pageLeftResource-ClearVideo',
  pageLeftResourceSetPreviewVideo: 'pageLeftResource-SetPreviewVideo',
  pageLeftResourceEditTemplate: 'pageLeftResource-EditTemplate',
  paginationJumpTo: 'pagination-JumpTo',
  paginationClickDropDownBox: 'pagination-ClickDropDownBox',
  publicFileSelectSelectedChange: 'publicFileSelect-SelectedChange',
  publicFileTreeSearchShow: 'publicFileTree-SearchShow',
  publicFileTreeAddFolder: 'publicFileTree-AddFolder',
  publicFileTreeShowUploadVideo: 'publicFileTree-ShowUploadVideo',
  publicFileTreeRefreshFileList: 'publicFileTree-RefreshFileList',
  publicFileTreeGetSearchFile: 'publicFileTree-GetSearchFile',
  publicFileTreeGetCurrentNode: 'publicFileTree-GetCurrentNode',
  publicFileTreeDeleteFolder: 'publicFileTree-DeleteFolder',
  publicFileTreeDeleteFile: 'publicFileTree-DeleteFile',
  publicFileTreeEditFile: 'publicFileTree-EditFile',
  selectSearchRChangeIconStatus: 'selectSearchR-ChangeIconStatus',
  shareConfirmConfirm: 'shareConfirm-Confirm',
  transferPanelClearQuery: 'transferPanel-ClearQuery',
  transferAddToRight: 'transfer-AddToRight',
  transferAddToLeft: 'transfer-AddToLeft',
  videoCShowFocusIcon: 'videoC-ShowFocusIcon',
  videoCUpdateIconStatus: 'videoC-UpdateIconStatus',
  videoCShowSunAdjust: 'videoC-ShowSunAdjust',
  addEditFolderSave: 'addEditFolder-Save',
  addEditFolderAdd: 'addEditFolder-Add',
  addEditFolderCanCel: 'addEditFolderCanCel',
  programTemplateListSearchShow: 'programTemplateList-SearchShow',
  programTemplateListAddProgram: 'programTemplateList-AddProgram',
  programTemplateListGetProgramList: 'programTemplateList-GetProgramList',
  programTemplateListGetCheck: 'programTemplateList-GetCheck',
  programTemplateListEditTemplate: 'programTemplateList-EditTemplate',
  programTemplateListDeleteTemplate: 'programTemplateList-DeleteTemplate',
  scheduleTemplateListSearchShow: 'scheduleTemplateList-SearchShow',
  scheduleTemplateListAddSchedule: 'scheduleTemplateList-AddSchedule',
  scheduleTemplateListGetSchedulerList: 'scheduleTemplateList-GetSchedulerList',
  scheduleTemplateListGetCheck: 'scheduleTemplateList-GetCheck',
  scheduleTemplateListEditTemplateList: 'scheduleTemplateList-EditTemplateList',
  scheduleTemplateListDeleteTemplateList: 'scheduleTemplateList-DeleteTemplateList',
  sourceListSearchShow: 'sourceList-SearchShow',
  sourceListFilterShow: 'sourceList-FilterShow',
  sourceListSearchChange: 'sourceList-SearchChange',
  sourceListPrevent: 'sourceList-Prevent',
  sourceListSwitchShowBF: 'sourceList-SwitchShowBF',
  sourceListClickSource: 'sourceList-ClickSource',
  // 以下是新加的
  headerBackWorkbench: 'header-BackWorkbench',
  headerShowPop: 'header-ShowPop',
  headerOpenOutput: 'header-OpenOutput',
  headerChangeLangEventEN: 'header-ChangeLangEvent-EN',
  headerChangeLangEventZH: 'header-ChangeLangEvent-ZH',
  headerLogout: 'header-Logout',
  headerGoLive: 'header-GoLive',
  headerUserInfoSignOut: 'header-UserInfo-SignOut',
  headerChangeToSupport: 'header-ChangeToSupport',
  headerSecondaryRecordSearch: 'header-SecondaryRecord-Search',
  headerSecondaryRecordFilter: 'header-SecondaryRecord-Filter'
}
export const scheduler = {
  schedulerDuplicateApply: 'scheduler-Duplicate',
  schedulerTabelSaveTemplate: 'scheduler-Tabel-SaveTemplate',
  schedulerTabelDeleteTemplate: 'scheduler-Tabel-DeleteTemplate',
  schedulerCalendarEventEditSave: 'scheduler-CalendarEvent-Edit-Save',
  schedulerCalendarEventDelete: 'scheduler-calendarEvent-Delete',
  schedulerFileAdd: 'scheduler-file-add',
  schedulerCalendarCreateBoxOpen: 'scheduler-calendarCreateBox-open',
  schedulerCalendarCreateEvent: 'scheduler-Calendar-CreateEvent',
  schedulerCalendarEventsDeleteSubevent: 'scheduler-Calendar-Events-DeleteSubevent',
  schedulerCalendarEventsAddSubevent: 'scheduler-Calendar-Events-AddSubevent',
  schedulerCalendarEventDuplicate: 'scheduler-CalendarEvent-Duplicate',
  schedulerLeftSourceMedia: 'scheduler-LeftSource-Media',
  schedulerLeftSourceLiveSource: 'scheduler-LeftSource-LiveSource',
  schedulerLeftSourceProgramTemplate: 'scheduler-LeftSource-ProgramTemplate',
  schedulerLeftSourceScheduleTemplate: 'scheduler-LeftSource-ScheduleTemplate',
  schedulerFileTreeHeaderSearchShow: 'scheduler-FileTreeHeader-SearchShow',
  schedulerFileTreeHeaderAddFolder: 'scheduler-FileTreeHeader-AddFolder',
  schedulerFileTreeHeaderUploadVideoFile: 'scheduler-FileTreeHeader-UploadVideoFile',
  schedulerFileTreeHeaderRefreshList: 'scheduler-FileTreeHeader-RefreshList',
  schedulerFileTreeAddFolder: 'scheduler-FileTree-AddFolder',
  schedulerFileTreeDeleteFolder: 'scheduler-FileTree-DeleteFolder',
  schedulerFileTreeEditFile: 'scheduler-FileTree-EditFile',
  schedulerFileTreeDeleteFile: 'scheduler-FileTree-DeleteFile',
  schedulerLeftSourceClearVideo: 'scheduler-LeftSource-ClearVideo',
  schedulerLeftVideoPlay: 'scheduler-LeftVideo-Play',
  schedulerFileTreeHeaderAddFolderSave: 'scheduler-FileTreeHeader-AddFolder-Save',
  schedulerProgramTemplateHeaderAddSave: 'scheduler-ProgramTemplate-Header-Add-Save'
}
export const workbench = {
  workbenchChannelEnter: 'workbench-Channel-Enter',
  workbenchChannelCloseProgram: 'workbench-Channel-CloseProgram',
  workbenchChannelMoreShareProgram: 'workbench-Channel-More-ShareProgram',
  workbenchChannelMoreSettingProgram: 'workbench-Channel-More-SettingProgram',
  workbenchChannelMoreDeleteProgram: 'workbench-Channel-More-DeleteProgram'
}
